import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { AuthorizationService, CoreService, DocumentService, LoaderService, PortalService, SecurityService } from 'src/app/services';
import { Helpers } from 'src/app/helpers';
import { IPortalConfig, ITabs, IViewerParams, NotificationType, PlatForm, ViewerContentType,DocumentType } from 'src/app/models';
import { Dispatch } from 'redux';
import { environment } from 'src/environments/environment';
declare var window: any;
import MarkdownIt from 'markdown-it';
import sanitizeHtml from 'sanitize-html';
import { ChatService } from 'src/app/services/chat.service';
import { Subscription } from 'rxjs';
import { Constants } from '../../models/constants';
import { TopNotificationService } from '../top-notification/top-notification.service';
import { AIMessage } from 'src/app/models/AI/ai-message';
import { HttpClient } from '@angular/common/http';
import { CommonCoreService } from 'src/app/services/common-core.service';
import { Actions, AssetTracking, AssetViewSources } from 'src/app/models/document/assettracking';
import { DocumentViewerComponent } from '../document-viewer/document-viewer.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';
import { CitationService } from 'src/app/services/citation.service';
import { CitationDetail } from 'src/app/models/AI/citation';


@Component({
    selector: 'medpt-raspberry-ai',
    templateUrl: './raspberry-ai.component.html',
    styleUrl: './raspberry-ai.component.scss',
    standalone: false
})
export class RaspberryAIComponent implements OnInit, AfterViewInit, OnDestroy {
  cdnEndPoint = environment.cdnEndPoint;
  isChatbotOpen = false;
  user: any;
  isPortalSelected: boolean = false;
  attachmentBtn: any | null;
  attachmentInput: any | null;
  connectionResult: any;
  directLine: any = null;
  store: any = null;
  userId: string = '';
  conversationId: string = '';
  markdownProcessor = new MarkdownIt(); // Initialize markdown-it
  citationMapping: { [displayName: string]: string } = {};
  portalInfo!: IPortalConfig;
  isAIChatEnabled = false;
  isMaximized = false;
  isMinimized = false;
  isResizing = false;
  isRestored = false;
  startX = 0;
  startY = 0;
  startWidth = 0;
  startHeight = 0;
  startTop = 0;
  startLeft = 0;
  private subscription: Subscription | undefined;
  isRaspberryAI: boolean = (Helpers.getPlatformId() == PlatForm.RaspberryAI);
  webChatInstance :any;
  @ViewChild('chatbox', { static: false }) chatbox!: ElementRef;
  assetTracking!:AssetTracking;
  private removeChatClickListener?: () => void;
  portalId!: number;

  // Citation popover state
  showCitationPopover = false;
  citationPopoverData: CitationDetail | null = null;
  citationPopoverX = 0;
  citationPopoverY = 0;

  statusMessage: string = '';
  statusStage: string = '';
  isWaitingForResponse: boolean = false;
  private isFeedbackPending: boolean = false;
  isUserReviewer:boolean =false;
  enableMic: boolean = true; // enable the browser Web Speech mic button
  // Copilot-style landing: show suggested prompts until the first user message is sent
  hasStartedConversation: boolean = false;
  suggestedPrompts: string[] = [];
  constructor(
    private coreService: CoreService,
    private securityService: SecurityService,
    private elementRef: ElementRef,
    private portalService: PortalService,
    private renderer: Renderer2,
    private chatService: ChatService,
    private authorizationService: AuthorizationService,
    private notificationService: TopNotificationService,
    private commonCoreService: CommonCoreService,
    private http: HttpClient,
    private documentService: DocumentService,
    private loaderService: LoaderService,
    private modelDialogService: NgbModal,
    public activatedRoute: ActivatedRoute,
    private router: Router,
    private citationService: CitationService,
  ) {

  }
  openChatbot() {
    this.isChatbotOpen = true;
    this.isMinimized = false;
    this.isMaximized = false;
    this.isRestored = false;
    this.openChatbotModal();
  }

  minimizeChatbot() {
    this.isMinimized = true;
    this.isChatbotOpen = false;
    this.isMaximized = false;
  }

  restoreChatbot() {
    this.isMinimized = false;
    this.isChatbotOpen = true;
    this.isMaximized = false;
    this.isRestored = true;
    this.openChatbotModal();
  }

  toggleSize() {
    const chatboxElement = this.chatbox.nativeElement;

    if (this.isMaximized) {
      // Reset to default (minimized mode)
      chatboxElement.classList.remove('floating-chatbox', 'maximized');
      chatboxElement.classList.add('floating-chatbox');
      // Remove inline styles to let CSS take effect
      chatboxElement.style.width = '';
      chatboxElement.style.height = '';
      chatboxElement.style.top = '';
      chatboxElement.style.left = '';
    } else {
      // Set maximized size

      chatboxElement.style.width = '';
      chatboxElement.style.height = '';
      chatboxElement.style.top = '';
      chatboxElement.style.left = '';
      chatboxElement.classList.remove('floating-chatbox');
      chatboxElement.classList.add('floating-chatbox', 'maximized');
    }

    this.isMaximized = !this.isMaximized;
  }
  onResizeStart(event: MouseEvent) {
    if (this.isMaximized) return; // Disable resizing when maximized
    this.isResizing = true;
    this.startX = event.clientX;
    this.startY = event.clientY;

    const chatboxElement = this.chatbox.nativeElement;
    this.startWidth = chatboxElement.offsetWidth;
    this.startHeight = chatboxElement.offsetHeight;
    this.startTop = chatboxElement.offsetTop;
    this.startLeft = chatboxElement.offsetLeft;

    event.preventDefault();
  }

  @HostListener('document:mousemove', ['$event'])
  onResizing(event: MouseEvent) {
    if (this.isResizing) {
      event.preventDefault();
      const chatboxElement = this.chatbox.nativeElement;

      const widthChange = this.startX - event.clientX;
      const heightChange = this.startY - event.clientY;
      
      chatboxElement.style.width = `${this.startWidth + widthChange}px`;
      chatboxElement.style.height = `${this.startHeight + heightChange}px`;
      
      let topVal=0;
      if(this.startTop - heightChange <= 0){
        topVal = 45;
      }else{
        topVal = this.startTop - heightChange;
      };
      
      // Move the chatbox upwards as it resizes
      chatboxElement.style.top = `${topVal}px`;
      chatboxElement.style.left = `${this.startLeft - widthChange}px`;
    }
  }

  @HostListener('document:mouseup')
  onResizeEnd() {
    this.isResizing = false;
  }
  
  ngOnInit(): void {
    
      this.portalService.portalConfiguation.subscribe(portalInfo=>{
      this.portalInfo = portalInfo;
      if(!Helpers.isNullOrUndefined(this.directLine)){
            this.directLine.connectionStatus$.subscribe((status: number) => {
              if(status == 2){
                this.directLine.postActivity({
                type: 'endOfConversation',
                from: { id: this.conversationId, name: this.user.Name },
                code: 'completedSuccessfully',   // Optional: can be 'userCancelled', 'botTimedOut', etc.
                text: 'User has ended the chat.'
              }).subscribe(
                (id:any) => {
                this.directLine.end(); 
                this.isRestored = false;
                this.closeChatbot();
                (error:any) => console.error('Error posting endOfConversation activity:', error)
              }
              );  
              
          }
        });
      }     

        this.isPortalSelected =
          window.location.pathname.toLowerCase().startsWith('/go') ||
          window.location.pathname.toLowerCase().startsWith('/report');
          this.isUserReviewer = this.authorizationService.isNavigationOrFeatueAllowed(Constants.ASSIGN_REVIEWER_FEATURE_NAME);  

        if(this.authorizationService.isNavigationOrFeatueAllowed(Constants.RASPberryAI_CHATBOT_FEATURE_NAME) && this.isPortalSelected && !Helpers.isNullOrUndefined(this.portalInfo.PortalID)){
            this.coreService
            .generateWebChatToken(this.portalInfo.PortalID)
            .then((result: any) => {
              if (result.Success) {
                this.isAIChatEnabled = true;
                this.connectionResult = result.Data;         
                this.conversationId = result.Data.ConversationId;
                localStorage.setItem('conversationId', this.conversationId);
                this.coreService
                  .getAIPredefinedQuestions(this.portalInfo.SponsorName!, this.portalInfo.PortalID!)
                  .then((res) => {
                    this.suggestedPrompts = (res?.PredefinedQuestions ?? []).slice(0, 3);
                  });
                const currentUser = this.securityService.currentUserValue;
                this.userId = currentUser.UserGuid; // Ensure userId is set once
                this.user = {
                  UserID: currentUser.UserID,
                  Id: currentUser.UserGuid,
                  FirstName: currentUser.FirstName,
                  LastName: currentUser.LastName,
                  Email: currentUser.UserName,
                  Name: currentUser.FirstName + ' ' + currentUser.LastName,
                  Product:
                    Helpers.getPlatformId() == PlatForm.TriPort
                      ? 'TriPort'
                      : Helpers.getPlatformId() == PlatForm.CloudPort 
                      ? 'CloudPort'
                      :'RASPberryAI',
                  ConversationId: result.ConversationId,
                };
                if(Helpers.getPlatformId() == PlatForm.RaspberryAI){
                    this.openChatbotModal();
                }
            } else {
              this.isAIChatEnabled = false;
            }
          });
        }else{
          this.isAIChatEnabled = false;
        } 

      
    });

     
    this.subscription = this.chatService.imageClick$.subscribe(() => {
      this.openChatbotModal();
    });
    
   
  
  }

  // Remove WebChat's external link icon manually
  sanitizeOptions = {
    allowedTags: sanitizeHtml.defaults.allowedTags.concat(['a']),
    allowedAttributes: {
      a: ['href', 'target', 'rel', 'title', 'data-cite-href'],
    },
    allowedSchemes: ['http', 'https', 'ftp', 'mailto'],
    allowSchemeRelative: true,
    transformTags: {
      'a': (tagName: string, attribs: any) => {
        const href = attribs.href || '';
        // Preserve cite: and plain documentId links via data attribute
        if (href.startsWith('cite:') || (href && !href.startsWith('http') && !href.startsWith('/') && !href.startsWith('#') && !href.startsWith('mailto:'))) {
          return {
            tagName: 'a',
            attribs: {
              ...attribs,
              'data-cite-href': href,
              'href': '#'
            }
          };
        }
        return { tagName, attribs };
      }
    },
    exclusiveFilter: (frame: any) => {
      return (
        frame.tag === 'img' &&
        frame.attribs.class?.includes(
          'webchat__render-markdown__external-link-icon'
        )
      );
    },
  };

  // replacePlaceholdersWithMarkdown(
  //   text: string,
  //   citationMapping: { [key: string]: string }
  // ): string {
  //   if (!text) {
  //     return text;
  //   }

  //   let references: string[] = [];
  //   let hasCitations = false; // Flag to check if citations exist
  //   let modifiedText = text.replace(
  //     /\[([0-9]+)\]:\s*cite:\d+\s*"Citation-\d+"/g,
  //     (match, p1, citationText) => {
  //       const key = `cite:${p1}`;
  //       let displayName = citationMapping[key]; // Retrieve full file name
  //       if (!displayName) {
  //         console.warn(
  //           `Warning: Citation ${p1} is missing in citationMapping.`
  //         );
  //         return `[${p1}]: cite:${p1} "${displayName}"`; // Keep the original citation if missing
  //       }
  //       let displayNameWithNoExtension = this.removeExtension(displayName);
  //       let displayNameWithPdf = displayNameWithNoExtension + '.pdf';
  //       let docLink = `${this.cdnEndPoint}/triport/AI/${encodeURIComponent(
  //         displayNameWithPdf
  //       )}`;
  //       hasCitations = true;
  //       references.push(
  //         `\u200B[${p1}]: [${displayNameWithNoExtension}](${docLink})`.trim()
  //       ); // Ensures rendering
  //       return ' '; // Remove the original citation reference
  //     }
  //   );
  //   console.log(modifiedText);
  //   // If `citationMapping` is empty, remove all citation references
  //   if (!hasCitations) {
  //     modifiedText = modifiedText.replace(/\[([0-9]+)\]/g, ''); // Remove all `[1]`, `[2]`, etc.
  //   }

  //   // Ensure "References" appears only if citations exist
  //   if (hasCitations) {
  //     let separator = '\u200B\n\n'; // Zero-width space + forced new line
  //     let referencesSection =
  //       `**References**${separator}` + references.join(separator);
  //     console.log(referencesSection);
  //     console.log(references);  
  //     return modifiedText.trim() + separator + referencesSection;
  //   }
  //   return modifiedText; // Return cleaned text
  // }

  ngAfterViewInit(): void {}
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
     this.removeChatClickListener?.();
    this.removeChatClickListener = undefined;
  }
  closeChatbot() {
    this.isChatbotOpen = false;
    this.isMaximized = false;
    this.isMinimized = false;
    // this.directLine.connectionStatus$.subscribe((status: number) => {
    //   if(status == 2){
    //     this.directLine.postActivity({
    //       type: 'endOfConversation',
    //       from: { id: this.conversationId, name: this.user.Name },
    //       code: 'completedSuccessfully',   // Optional: can be 'userCancelled', 'botTimedOut', etc.
    //       text: 'User has ended the chat.'
    //     }).subscribe(
    //       (id:any) => {
            
    //       (error:any) => console.error('Error posting endOfConversation activity:', error)
    //     }
    //     );
    //   }
    // });
  }
  removeExtension = (filename: string): string => {
    const lastDotIndex = filename?.lastIndexOf('.');
    return lastDotIndex === -1
      ? filename
      : filename?.substring(0, lastDotIndex);
  };
  // cleanCitationName(text: string): string {
  //   if (!text) return '';

  //   // Remove unnecessary spaces and trim the text
  //   return text.replace(/\s+/g, ' ').trim();
  // }
  // replacePlaceholders(
  //   text: string,
  //   citationMapping: { [key: string]: string }
  // ): string {
  //   if (!text) {
  //     return text; // Return as is if text is empty
  //   }

  //   return text.replace(
  //     /\[([0-9]+)\]:\s*cite:\d+\s*"Citation-\d+"/g,
  //     (match, p1) => {
  //       const key = `cite:${p1}`;
  //       const displayName = citationMapping[key];
  //       const fileNamewithNoExtension = this.removeExtension(displayName);
  //       console.log(displayName);
  //       if (displayName) {
  //         return `[${p1}]: cite:${p1} "${fileNamewithNoExtension}"`; // Keep the same link structure
  //       }
  //       return match; // If no match, return the original text
  //     }
  //   );
  // }

  // extractCitations(activity: any): { [key: string]: string } {
  //   const citationMapping: { [key: string]: string } = {};

  //   if (activity.entities) {
  //     activity.entities.forEach((entity: any) => {
  //       if (entity.type === 'https://schema.org/Message' && entity.citation) {
  //         entity.citation.forEach((citation: any) => {
  //           if (citation['@id'] && citation.appearance) {
  //             citationMapping[citation['@id']] = citation.appearance.name;
  //           }
  //         });
  //       }
  //     });
  //   }
  //   return citationMapping;
  // }
  openNewChatbotModal(){
    // start a completely fresh conversation
    this.resetConversationPendingState();
    this.hasStartedConversation = false;
    this.removeChatClickListener?.();
    this.removeChatClickListener = undefined;

    if (this.directLine?.end) {
      try {
        this.directLine.end();
      } catch {
        // ignore stale conversation shutdown issues
      }
    }

    this.directLine = null;
    this.store = null;

    if (this.portalInfo?.PortalID && this.authorizationService.isNavigationOrFeatueAllowed(Constants.RASPberryAI_FEATURE_NAME)) {
      this.coreService.generateWebChatToken(this.portalInfo.PortalID).then((result: any) => {
        if (!result?.Success || !result?.Data?.Token) {
          this.isAIChatEnabled = false;
          return;
        }

        this.connectionResult = result.Data;
        this.conversationId = result.Data.ConversationId;
        localStorage.setItem('conversationId', this.conversationId);

        const currentUser = this.securityService.currentUserValue;
        if (!currentUser) {
          this.isAIChatEnabled = false;
          return;
        }

        this.userId = currentUser.UserGuid;
        this.user = {
          UserID: currentUser.UserID,
          Id: currentUser.UserGuid,
          FirstName: currentUser.FirstName,
          LastName: currentUser.LastName,
          Email: currentUser.UserName,
          Name: currentUser.FirstName + ' ' + currentUser.LastName,
          Product:
            Helpers.getPlatformId() == PlatForm.TriPort
              ? 'TriPort'
              : Helpers.getPlatformId() == PlatForm.CloudPort
              ? 'CloudPort'
              : 'RASPberryAI',
          ConversationId: result.Data.ConversationId,
        };

        this.isAIChatEnabled = true;
        this.openChatbotModal();
      });
      return;
    }

    this.isAIChatEnabled = false;
  }
  
  openChatbotModal() {
    this.resetConversationPendingState();

    if(this.securityService.currentUserValue == null){
      setTimeout(() => {
        this.notificationService.showNotification('Session expired.', NotificationType.Error);
      });
      this.securityService.logout();
      return;
    }
    this.isChatbotOpen = true;

    setTimeout(() => {
      this.directLine = window.WebChat.createDirectLine({
        token: this.connectionResult.Token,
        websocket:true
      });

      // Override the Markdown renderer to prevent WebChat from adding external link icons
      const markdownItRenderer = new MarkdownIt({
        html: true, // Enable HTML tags in markdown
        breaks: true, // Convert '\n' in paragraphs into <br>
        linkify: true, // Automatically detect and convert links
      });

      markdownItRenderer.renderer.rules['link_open'] = (
        tokens: any,
        idx: any,
        options: any,
        env: any,
        self: any
      ) => {
        const href = tokens[idx].attrGet('href') || '';
        // Don't add target="_blank" on cite: links or plain documentId references
        if (!href.startsWith('cite:')) {
          tokens[idx].attrSet('target', '_blank'); // Opens links in a new tab
          tokens[idx].attrSet('rel', 'noopener noreferrer'); // Security best practice
        }
        tokens[idx].attrSet('title', 'Click to open this document'); // Custom title
        return self.renderToken(tokens, idx, options);
      };
      this.store = window.WebChat.createStore(
        {},
        ({ dispatch }: { dispatch: Dispatch }) =>
          (next: (arg0: any) => any) =>
          (action: any) => {
            if (action.type === 'DIRECT_LINE/INCOMING_ACTIVITY') {
              const activity = action.payload.activity;

              // Suppress statusUpdate events from rendering in chat
              if (activity.type === 'event' && activity.name === 'statusUpdate') {
                const val = typeof activity.value === 'string' ? JSON.parse(activity.value) : activity.value;
                const stage = val?.stage || val?.Stage;
                const label = val?.label || val?.Label;
                if (stage === 'DONE') {
                  this.isWaitingForResponse = false;
                  this.isFeedbackPending = false;
                  this.hideStatusIndicator();
                  this.toggleSendBox(false);
                } else if (label) {
                  this.statusStage = stage;
                  this.showStatusIndicator(label);
                }
                return; // Don't render in chat
              }

              if (activity.type === 'message' && activity.from.role === 'bot') {
                if(this.securityService.currentUserValue == null){
                  setTimeout(() => {
                           this.notificationService.showNotification('Session expired.', NotificationType.Error);
                         });
                  this.securityService.logout();
                  return;
                }

                // Final answer arrived — remove status indicator
                // Only hide if the message has actual text (not an empty/system message)
                if (activity.text) {
                  if (this.isFeedbackPending) {
                    this.isFeedbackPending = false;
                  } else {
                    this.hideStatusIndicator();
                    this.isWaitingForResponse = false;
                    this.toggleSendBox(false);
                  }
                }

                // Parse citations from channelData
                if (activity.channelData) {
                  this.citationService.parseCitations(activity.channelData);
                }
                
                // const citationMapping = this.extractCitations(activity);
                // console.log(citationMapping);
                // activity.text = this.replacePlaceholdersWithMarkdown(
                //   activity.text,
                //   citationMapping
                // );
              }
            
                  
            }
            if(action.type === 'DIRECT_LINE/POST_ACTIVITY'){
                    const isFeedbackAction = !!action.payload.activity.value?.ActionType;
                    // Block sending while waiting for a response
                    if (this.isWaitingForResponse && action.payload.activity.type === 'message' && !isFeedbackAction) {
                      return;
                    }
                    // Only show status for user messages, not events (e.g. startConversation) or feedback actions
                    if (action.payload.activity.type === 'message' && !isFeedbackAction){
                      this.hasStartedConversation = true; // hide the landing / suggested prompts
                      this.statusStage = 'ANALYZING';
                      this.showStatusIndicator('Analyzing your question...');
                      this.isWaitingForResponse = true;
                      this.toggleSendBox(true);
                    }
                    if (isFeedbackAction) {
                      this.isFeedbackPending = true;
                    }

                    action = {
                ...action,
                payload: {
                  ...action.payload,
                  activity: {
                    ...action.payload.activity,
                    channelData: {
                      ...action.payload.activity.channelData, // Preserve existing channelData
                     'SponsorName':this.portalInfo.SponsorName,
                     'PortalName':this.portalInfo.PortalName,
                     'PortalId': this.portalInfo.PortalID,
                     'UserId':this.user.UserID,
                     'RoleId':this.portalInfo.RoleId,
                     'SiteId':this.portalInfo.SiteId,
                     'IsUserReviewer':this.isUserReviewer
                    }
                  }
                }
              }
            }
            
            return next(action);
          }
      );
      setTimeout(() => {
        this.directLine.activity$.subscribe((activity: any) => {
          if(activity.type ==='message' && !Helpers.isNullOrUndefined(activity.text)){
            // const citationMapping = this.extractCitations(activity);
            // const response  = this.replacePlaceholdersWithMarkdown(
            //     activity.text,
            //     citationMapping
            // );
            // const aiMessage:AIMessage =new AIMessage();
            // aiMessage.Message = response;
            // aiMessage.MessageBy = Helpers.isNullOrUndefined(activity.from.role) ? "user" : activity.from.role;
            // aiMessage.RoleId = this.portalInfo.RoleId!;
            // this.coreService.insertRaspberryAIMessage(this.portalInfo.SponsorName!,this.portalInfo.PortalID!,aiMessage);
          }
           
        });
       
    }, 200); // Delay to ensure stability
      const styleSet = window.WebChat.createStyleSet({
        backgroundColor: '#FFFFFF',
        primaryFont: "'Fabrikat-Regular', 'DejaVu Sans', sans-serif",
        bubbleMaxWidth: Math.min(window.innerWidth * 0.8, 700),
        botAvatarBackgroundColor: '#FFFFFF',
        suggestedActionTextColor: 'black',
        suggestedActionBorderColor: '#C93C66',
        suggestedActionBackground: '#FFFFFF',
        userAvatarBackgroundColor: '#C93C66',
      });

      styleSet.textContent = {
        ...styleSet.textContent,
      };
      const hostConfig = {
        fontFamily: "'Fabrikat-Regular', 'DejaVu Sans', sans-serif",
      };
      const avatarOptions = {
        botAvatarInitials: '',
        hideUploadButton: true,
        hideSendStatus: true,
        botAvatarImage:
          environment.cdnEndPoint +
          environment.cdnSharedImagesFolder +
          'AI_Chat_Bot_Red.svg',
        userAvatarInitials: this.user?.Name.match(/(^\S\S?|\s\S)?/g)
          .map((v: string) => v.trim())
          .join('')
          .match(/(^\S|\S$)?/g)
          .join('')
          .toLocaleUpperCase(),
      };
      //const actionMiddle = this.cardActionMiddleware();
     const chatContainer = this.elementRef.nativeElement.querySelector('#webchat');
      
     
 // Prevent double registration
    if (this.removeChatClickListener) {
      this.removeChatClickListener?.();
      this.removeChatClickListener = undefined;
    }
    
    this.removeChatClickListener = this.renderer.listen(
      chatContainer,
      'click',
      (event: MouseEvent) => {
        const target = event.target as HTMLElement;
        const anchor = target.closest('a') as HTMLAnchorElement | null;

        if (!anchor) return;

        // Check data-cite-href first (set by sanitizer for cite: and documentId links)
        const citeHref = anchor.getAttribute('data-cite-href') || '';

        // Handle inline citation clicks (href starts with "cite:")
        if (citeHref.startsWith('cite:')) {
          event.preventDefault();
          event.stopPropagation();
          this.handleInlineCitationClick(citeHref, event);
          return;
        }

        // Handle reference link clicks (href is a plain documentId)
        if (citeHref && !citeHref.startsWith('http') && !citeHref.startsWith('/') && !citeHref.startsWith('#')) {
          event.preventDefault();
          event.stopPropagation();
          this.handleReferenceLinkClick(citeHref, event);
          return;
        }

        // Fallback: existing behavior for other links
        if (anchor) {
          event.preventDefault();
          event.stopPropagation();
          const href = anchor.getAttribute('href') || '';
          const docId = href.split('/').pop();
          this.openDocumentModal(docId);
        }
      }
    );
      try {
        // Mic is handled by a custom button (see addMicButton) using the browser's
        // native SpeechRecognition, so the normal WebChat send button stays visible.
        // We intentionally do NOT pass a webSpeechPonyfillFactory here.
        this.webChatInstance = window.WebChat.renderWebChat(
          {
            directLine: this.directLine,
            //cardActionMiddleware:actionMiddle,
            locale: 'en-US',
            styleSet: styleSet,
            styleOptions: avatarOptions,
            adaptiveCardHostConfig: hostConfig,
            store: this.store,
            userID: this.userId,
            user: { id: this.userId, name: this.user.Name },
            sendTypingIndicator: true,
            overrideLocalizedStrings: {
              TEXT_INPUT_PLACEHOLDER: 'Ask your question',
            },
            markdownIt: markdownItRenderer, // Use markdown-it for rendering
            renderMarkdown: (text: string) => {
              return sanitizeHtml(
                markdownItRenderer.render(text),
                this.sanitizeOptions
              );
            }
          },
          //this.elementRef.nativeElement.querySelector('#webchat')
          chatContainer
        );
        this.addDisclaimer();
        this.addMicButton();
        
      } catch (error) {
        console.error('Error rendering WebChat:', error);
      }
    }, 0); // Ensure DOM is rendered before WebChat renders
  }
  addDisclaimer() {
    const interval = setInterval(() => {
      const sendBox =
        this.elementRef.nativeElement.querySelector('.webchat__send-box');
      if (
        sendBox &&
        !this.elementRef.nativeElement.querySelector('.custom-disclaimer')
      ) {
        const disclaimer = this.renderer.createElement('div');
        this.renderer.addClass(disclaimer, 'custom-disclaimer');
        this.renderer.setProperty(
          disclaimer,
          'textContent',
          'Generated by AI. Please check reference material links for complete information.'
        );
        this.renderer.appendChild(sendBox, disclaimer);
        clearInterval(interval);
      }
    }, 500);
  }

  // Inject a custom microphone button into WebChat's send box. It uses the browser's
  // native SpeechRecognition to dictate text into the "Ask your question" box WITHOUT
  // sending — the user reviews the text and presses the normal Send button.
  private recognition: any = null;
  private isListening = false;

  addMicButton() {
    if (!this.enableMic) {
      return;
    }
    const SpeechRecognition =
      (window as any).SpeechRecognition || (window as any).webkitSpeechRecognition;
    if (!SpeechRecognition) {
      // Browser doesn't support speech recognition; skip the mic button.
      return;
    }

    const interval = setInterval(() => {
      const sendBoxMain =
        this.elementRef.nativeElement.querySelector('.webchat__send-box__main') ||
        this.elementRef.nativeElement.querySelector('.webchat__send-box');
      if (
        sendBoxMain &&
        !this.elementRef.nativeElement.querySelector('.rai-mic-button')
      ) {
        const micBtn = this.renderer.createElement('button');
        this.renderer.setAttribute(micBtn, 'type', 'button');
        this.renderer.addClass(micBtn, 'rai-mic-button');
        this.renderer.setAttribute(micBtn, 'title', 'Speak your question');
        this.renderer.setAttribute(micBtn, 'aria-label', 'Speak your question');
        micBtn.innerHTML =
          '<svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true">' +
          '<path fill="currentColor" d="M12 2a3.5 3.5 0 0 1 3.5 3.5v5a3.5 3.5 0 0 1-7 0v-5A3.5 3.5 0 0 1 12 2Zm6 8.5a.75.75 0 0 1 1.5 0 7.5 7.5 0 0 1-6.75 7.463V21a.75.75 0 0 1-1.5 0v-3.037A7.5 7.5 0 0 1 4.5 10.5a.75.75 0 0 1 1.5 0 6 6 0 0 0 12 0Z"/>' +
          '</svg>';

        // Place the mic before the send button so both are visible.
        const sendButton = sendBoxMain.querySelector('.webchat__send-box__button');
        if (sendButton) {
          this.renderer.insertBefore(sendBoxMain, micBtn, sendButton);
        } else {
          this.renderer.appendChild(sendBoxMain, micBtn);
        }

        this.renderer.listen(micBtn, 'click', () => this.toggleDictation(micBtn));
        clearInterval(interval);
      }
    }, 500);
  }

  private toggleDictation(micBtn: HTMLElement) {
    const SpeechRecognition =
      (window as any).SpeechRecognition || (window as any).webkitSpeechRecognition;
    if (!SpeechRecognition) {
      return;
    }

    // If already listening, stop.
    if (this.isListening) {
      this.recognition?.stop();
      return;
    }

    this.recognition = new SpeechRecognition();
    this.recognition.lang = 'en-US';
    this.recognition.interimResults = true;
    this.recognition.continuous = false;

    this.isListening = true;
    this.renderer.addClass(micBtn, 'rai-mic-listening');

    this.recognition.onresult = (event: any) => {
      let finalText = '';
      let interim = '';
      for (let i = 0; i < event.results.length; i++) {
        const transcript = event.results[i][0].transcript;
        if (event.results[i].isFinal) {
          finalText += transcript;
        } else {
          interim += transcript;
        }
      }
      const text = (finalText || interim).trim();
      // Put the recognized text into WebChat's send box without sending.
      this.store?.dispatch({
        type: 'WEB_CHAT/SET_SEND_BOX',
        payload: { text },
      });
    };

    this.recognition.onerror = () => this.stopDictationUI(micBtn);
    this.recognition.onend = () => this.stopDictationUI(micBtn);

    try {
      this.recognition.start();
    } catch {
      this.stopDictationUI(micBtn);
    }
  }

  private stopDictationUI(micBtn: HTMLElement) {
    this.isListening = false;
    this.renderer.removeClass(micBtn, 'rai-mic-listening');
  }
  handleInlineCitationClick(href: string, event: MouseEvent): void {
    // Parse href: "cite:ref-abc123" or "cite:ref-abc123|ref-def456"
    // decodeURIComponent handles markdown-it encoding | as %7C
    const decoded = decodeURIComponent(href.replace('cite:', ''));
    const refIds = decoded.split('|');
    const chunks = this.citationService.getChunksByRefIds(refIds);

    if (chunks.length === 0) {
      // Fallback: try to extract documentId and open directly
      const docId = refIds[0]?.split(':')[0];
      if (docId) {
        this.openDocumentModal(docId);
      }
      return;
    }

    // Build a CitationDetail from the matched chunks (all belong to same or different documents)
    const firstChunk = chunks[0];
    const citation = this.citationService.getCitationByDocumentId(firstChunk.documentId);
    const filteredCitation: CitationDetail = {
      displayIndex: citation?.displayIndex ?? 0,
      documentId: firstChunk.documentId,
      title: firstChunk.title,
      chunks: chunks
    };
    this.showCitationPopoverAt(filteredCitation, event);
  }

  handleReferenceLinkClick(documentId: string, event: MouseEvent): void {
    // Reference links open document directly
    this.openDocumentModal(documentId);
  }

  showCitationPopoverAt(citation: CitationDetail, event: MouseEvent): void {
    const chatbox = this.chatbox.nativeElement as HTMLElement;
    const rect = chatbox.getBoundingClientRect();
    this.citationPopoverX = event.clientX - rect.left;
    this.citationPopoverY = event.clientY - rect.top;
    this.citationPopoverData = citation;
    this.showCitationPopover = true;
  }

  onCitationChunkSelected(event: { documentId: string; pageNumber: number; searchText: string; Source: string }): void {
    this.showCitationPopover = false;
    this.citationPopoverData = null;
    this.openDocumentWithCitation(event.documentId, event.pageNumber, event.searchText, event.Source);
  }

  onCitationPopoverDismissed(): void {
    this.showCitationPopover = false;
    this.citationPopoverData = null;
  }

  openDocumentWithCitation(documentId: string, pageNumber: number, searchText: string, Source?: string): void {
    this.loaderService.showLoader();
    const docId: any = documentId;
    this.documentService.getDocumentUrlByAssetId(<string>this.portalInfo.SponsorName, <number>this.portalInfo.PortalID, docId).then((result: any) => {
      if (result.SuccessFlag) {
        this.assetTracking = new AssetTracking();
        this.assetTracking.AssetId = docId;
        this.assetTracking.ActionId = Actions.View;
        this.assetTracking.AssetViewSourceId = AssetViewSources.RAIReferenceLink;
        this.insertAssetTracking(this.assetTracking);

        let params: IViewerParams = {
          DocumentUrl: result.Type == "URL" ? result.ViewingSessionID : "",
          ViewingSessionId: result.Type != "URL" ? result.ViewingSessionID : "",
          DownloadCallbackFunction: "DownloadDocument",
          DownloadCallbackFunctionParam: result.PersonAssetGuid,
          Anontation: false,
          Download: result.IsDownloadable,
          Print: result.IsDownloadable,
          PageNumber: pageNumber,
          SearchText: searchText?.split(/\s+/).slice(0, 3).join(' '),
          Score: Source,
          CitationBoundary:Source
        };
        console.log('Viewer Params:', params);
        let queryParam = btoa(unescape(encodeURIComponent(JSON.stringify(params))));
        let CONTENTURL = environment.viewerAppUrl + 'viewer/index';
        let tabData: ITabs = { AssetId: docId, DocumentType: DocumentType.Document, DocumentPath: result.DocumentPath, contentUrl: CONTENTURL, htmlContent: "", name: result.AssetName, PersonAssetGuid: result.PersonAssetGuid, PersonAssetId: result.PersonAssetID, showPlaceInRegDoc: result.IsDownloadable && result.EnablePlaceInRegDoceSafe, showPrintButton: false, showSignButton: result.Status.toLowerCase() == 'click to sign', SusarAssetStatusId: 0, ViewerContentType: ViewerContentType.Document, viewerToken: queryParam,EnableAIInsights: result.EnableAIInsights || false };

        let modalInstance = this.modelDialogService.open(DocumentViewerComponent, { fullscreen: true, scrollable: false });
        modalInstance.componentInstance.tabData = tabData;
        modalInstance.result.then((result: any) => {
          this.router.navigate([], { relativeTo: this.activatedRoute, queryParams: {}, replaceUrl: true });
        });
        modalInstance.closed.subscribe(() => {
          this.modelDialogService.dismissAll('');
        });

        modalInstance.componentInstance.updateSignatureEvent.subscribe((receivedEntry: any) => {
          if (receivedEntry) {
            // signature update handling
          }
        });
      } else {
        this.notificationService.showNotification("You do not have permission to view this document.", NotificationType.Error);
        this.loaderService.hideLoader();
      }
    }, (error) => {
      this.notificationService.showNotification("Failed to open document.", NotificationType.Error);
      this.loaderService.hideLoader();
    }).finally(() => { });
  }

  openDocumentModal(docId: any) {
    
     this.loaderService.showLoader();
              this.documentService.getDocumentUrlByAssetId(<string>this.portalInfo.SponsorName, <number>this.portalInfo.PortalID, docId).then((result: any) => {
                if (result.SuccessFlag) {
                  this.assetTracking = new AssetTracking();
                  this.assetTracking.AssetId = docId;
                  this.assetTracking.ActionId = Actions.View;
                  this.assetTracking.AssetViewSourceId = AssetViewSources.RAIReferenceLink;
                  this.insertAssetTracking(this.assetTracking);
                  let params: IViewerParams = {
                    DocumentUrl: result.Type == "URL" ? result.ViewingSessionID : "",
                    ViewingSessionId: result.Type != "URL" ? result.ViewingSessionID : "",
                    DownloadCallbackFunction: "DownloadDocument",
                    DownloadCallbackFunctionParam: result.PersonAssetGuid,
                    Anontation: false,
                    Download: result.IsDownloadable,
                    Print: result.IsDownloadable
                  };
                  let queryParam = btoa(unescape(encodeURIComponent(JSON.stringify(params))));
                  let CONTENTURL = environment.viewerAppUrl + 'viewer/index';
                  let tabData: ITabs = { AssetId: docId, DocumentType: DocumentType.Document, DocumentPath: result.DocumentPath, contentUrl: CONTENTURL, htmlContent: "", name: result.AssetName, PersonAssetGuid: result.PersonAssetGuid, PersonAssetId: result.PersonAssetID, showPlaceInRegDoc: result.IsDownloadable && result.EnablePlaceInRegDoceSafe, showPrintButton: false, showSignButton: result.Status.toLowerCase() == 'click to sign', SusarAssetStatusId: 0, ViewerContentType: ViewerContentType.Document, viewerToken: queryParam,EnableAIInsights: result.EnableAIInsights || false  };
                  
                  let modalInstance = this.modelDialogService.open(DocumentViewerComponent, { fullscreen: true, scrollable: false });
                  modalInstance.componentInstance.tabData = tabData;
                  modalInstance.result.then((result:any) => {
                    this.router.navigate([], { relativeTo: this.activatedRoute, queryParams: {}, replaceUrl: true });
                  });
                      modalInstance.closed.subscribe(() => {
                      this.modelDialogService.dismissAll('');
                      
              });
                
                  modalInstance.componentInstance.updateSignatureEvent.subscribe((receivedEntry: any) => {
                    if (receivedEntry) {
                      // need to test
                      // if (data.fromLink == undefined) {
                      //   this.documentService.getStatus(<string>this.portalInfo.SponsorName, <number>this.portalInfo.PortalID, result.PersonAssetGuid).then((statusResult: IAssetStatus) => {
                      //     data.Status = statusResult.Status;
                      //     data.DateCompleted = statusResult.DateCompleted;
                      //   });
                      // }
                    }
                  });
                  // need to test
                  // if (data.fromLink == undefined) {
                  //   this.documentService.getStatus(<string>this.portalInfo.SponsorName, <number>this.portalInfo.PortalID, result.PersonAssetGuid).then((statusResult: IAssetStatus) => {
                  //     data.Status = statusResult.Status;
                  //     data.DateCompleted = statusResult.DateCompleted;
                  //   });
                  // }
                  
                } else {
                  this.notificationService.showNotification("You do not have permission to view this document.", NotificationType.Error);
                  this.loaderService.hideLoader();
                }
              }, (error) => {
                this.notificationService.showNotification("Failed to open document.", NotificationType.Error);
                this.loaderService.hideLoader();
              }).finally(() => { });
    
           
          
  }
   insertAssetTracking(assetTracking:AssetTracking){
        this.documentService.insertAssetTracking(<string>this.portalInfo.SponsorName,assetTracking);
   }

  showStatusIndicator(message: string) {
    this.statusMessage = message;
  }

  // Populate a suggested prompt into WebChat's send box (does NOT send). The user
  // can review/edit the text and press Send themselves.
  sendSuggestedPrompt(text: string): void {
    if (this.isWaitingForResponse) {
      return;
    }
    this.store?.dispatch({ type: 'WEB_CHAT/SET_SEND_BOX', payload: { text } });
    // Focus the send box input so the user can edit immediately.
    setTimeout(() => {
      const input = this.elementRef.nativeElement.querySelector(
        '.webchat__send-box__text-box textarea, .webchat__send-box__text-box input'
      ) as HTMLElement | null;
      input?.focus();
    });
  }

  hideStatusIndicator() {
    this.statusMessage = '';
    this.statusStage = '';
  }

  private resetConversationPendingState(): void {
    this.isWaitingForResponse = false;
    this.isFeedbackPending = false;
    this.hideStatusIndicator();
    this.toggleSendBox(false);
  }

  private toggleSendBox(disabled: boolean) {
    const wrapper = this.elementRef.nativeElement.querySelector('.webchat-wrapper');
    if (wrapper) {
      if (disabled) {
        wrapper.classList.add('rai-waiting');
      } else {
        wrapper.classList.remove('rai-waiting');
      }
    }
  }
  
}


